import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";
const adminToken = secureStorage.getItem("adminToken");

export const addRoom = (FormData, navigate) => {
  axiosInstance
    .post("/room/add", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Room added successfully") {
        toast.success("Room added");
        navigate("/admin/rooms");
      } else {
        toast.error(res.data.message);
      }
    });
};

export const getRoomList = (setRoomData, Page, Limit, setPageData) => {
  axiosInstance
    .get(`/room/list?page=${Page}&limit=${Limit}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setRoomData(res.data.data);
      setPageData(res.data.totalPages);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};

export const getSingleRoom = (id, setFormData, setSelectedFacility) => {
  axiosInstance
    .get(`/room/room/${id}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setFormData({
        roomId: res.data.id,
        hotelId: res.data.hotelId,
        roomName: res.data.roomName,
        description: res.data.description,
        beds: res.data.beds,
        bathrooms: res.data.bathrooms,
        balcony: res.data.balcony,
        roomType: res.data.roomType,
        bedSize: res.data.bedSize,
        roomSize: res.data.roomSize,
        roomView: res.data.roomView,
        roomDirection: res.data.roomDirection,
        isSmokingAllow: res.data.isSmokingAllow,
        adults: res.data.adults,
        children: res.data.children,
        actualPrice: res.data.actualPrice,
        discount: res.data.discount,
        cancelationPolicy: res.data.cancelationPolicy,
        isAvailable: res.data.isAvailable,
        roomsAvailable: res.data.roomsAvailable,
        isBreakFastIncluded: res.data.isBreakFastIncluded,
        tax: res.data.tax,
        isRefundable: res.data.isRefundable,
        status: res.data.status,
        created_by: res.data.created_by,
        createdAt: res.data.createdAt,
        facilities: res.data.facilities,
        images: res.data.images,
      });
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const updateRoom = (FormData, navigate) => {
  axiosInstance
    .put("/room/update", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Room updated successfully") {
        toast.success("Room updated");
        navigate("/admin/rooms");
      } else {
        toast.error(res.data.message);
      }
    });
};
export const deleteRoom = (setRoomData, setPaginationData, Page, Limit, id) =>
  axiosInstance
    .delete(`/room/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (
        res.data.message === "Room and all related data deleted successfully"
      ) {
        toast.success("Room deleted");
        getRoomList(setRoomData, Page, Limit, setPaginationData);
      } else {
        toast.error("Please try again later");
      }
    })
    .catch((err) => {
      toast.error("something went Wrong");
    });

export const roombyHotel = (setRooms, hotelId) => {
  axiosInstance
    .get(`/room/by-hotel/${hotelId}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setRooms(res.data.data);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const allAvailability = (setData, hotelId, roomId) => {
  axiosInstance
    .get(`/room/availability?hotelId=${hotelId}&roomId=${roomId}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setData((prev) => {
        const apiData = res.data.data;

        const map = new Map();

        // keep existing calendar data
        prev.forEach((item) => {
          map.set(item.date, item);
        });

        // override with API data
        apiData.forEach((item) => {
          const formattedDate = new Date(item.date).toISOString().split("T")[0];

          map.set(formattedDate, {
            ...map.get(formattedDate),
            ...item,
            date: formattedDate,
          });
        });

        return Array.from(map.values());
      });
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const availability = (FormData) => {
  axiosInstance
    .post("/room/availability", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Availability saved successfully") {
        toast.success("Availability saved successfully");
      } else {
        toast.error(res.data.message);
      }
    });
};
export const updateAll = (
  setRoomData,
  Page,
  Limit,
  setPageData,
  CheckListData,
) => {
  axiosInstance
    .post(`/room/update-all`, CheckListData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Rooms updated successfully") {
        toast.success("Rooms updated");
        getRoomList(setRoomData, Page, Limit, setPageData);
      }
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
